const RECENTLY_CONFIRMED_EMAIL_KEY = "auth:recentlyConfirmedEmail";
const RECENTLY_CONFIRMED_EMAIL_TTL_MS = 10 * 60 * 1000;

function normalizeEmail(email) {
  return String(email || "").trim().toLowerCase();
}

export function markEmailRecentlyConfirmed(email) {
  if (typeof window === "undefined") return;

  const normalizedEmail = normalizeEmail(email);
  if (!normalizedEmail) return;

  sessionStorage.setItem(
    RECENTLY_CONFIRMED_EMAIL_KEY,
    JSON.stringify({
      email: normalizedEmail,
      confirmedAt: Date.now(),
    })
  );
}

export function isEmailRecentlyConfirmed(email) {
  if (typeof window === "undefined") return false;

  const normalizedEmail = normalizeEmail(email);
  if (!normalizedEmail) return false;

  try {
    const value = JSON.parse(
      sessionStorage.getItem(RECENTLY_CONFIRMED_EMAIL_KEY) || "null"
    );

    if (value?.email !== normalizedEmail) return false;

    const confirmedAt = Number(value?.confirmedAt || 0);
    const isExpired = Date.now() - confirmedAt > RECENTLY_CONFIRMED_EMAIL_TTL_MS;

    if (isExpired) {
      clearRecentlyConfirmedEmail();
      return false;
    }

    return true;
  } catch {
    clearRecentlyConfirmedEmail();
    return false;
  }
}

export function clearRecentlyConfirmedEmail() {
  if (typeof window === "undefined") return;
  sessionStorage.removeItem(RECENTLY_CONFIRMED_EMAIL_KEY);
}
